import Http from './../http';

const prefix = '/website-user-fields';

export const getAll = (encrypted_id) => Http.authApi().get(`${prefix}/all/${encrypted_id}`);

export const edit = formConfig => {
  return Http.authApi().put(`${prefix}/${formConfig.website.encrypted_id}`, formConfig);
};



// WEBPACK FOOTER //
// ./src/js/services/restrictArea/formFields.js